<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">人员的组ID转换为人员所在组的路径</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			把一个人所在人员组的ID，转换成所在组的路径信息。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public String SKFaceGroupID2GroupPath(String GroupID)；</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">GroupID：人员的组ID</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
         String类型，人员所在组的路径字符串
        </p>

		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">String personPath = skFaceSDKLive.SKFaceGroupID2GroupPath("123456");</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','人员的组ID转换为人员所在组的路径'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoideRouter.vue